module.exports = __webpack_public_path__ + "static/media/icon-handkey.1d974971.svg";